import React from 'react';
import moment from 'moment';
import { Map } from 'immutable';
import { connect } from 'react-redux';
import { Container, Row, Col } from 'reactstrap';
import Polyline from '@mapbox/polyline';
import * as MaterialUI from 'material-ui';
import FontAwesome from 'react-fontawesome';
import { push } from 'react-router-redux';

import * as viajesActions from 'modules/viajes/action';
import * as gruposActions from 'modules/grupos/action';
import * as generalActions from 'modules/general/action';
import { CancelarButtonC } from 'modules/general/component';
import { GMapsC } from 'modules/general/component';

import { Field, reduxForm, formValueSelector } from 'redux-form/immutable';
import { FORM_VIAJE } from 'modules/forms/formConstants';
import * as validations from 'modules/forms/validations';
import * as trayectosActions from 'modules/trayectos/action';
import * as vehiculosActions from 'modules/vehiculos/action';
import { AutoCompleteF, TextFieldF, TimePickerF, DatePickerF, ToggleFieldF } from 'modules/forms/component';
import { PenalizacionCancelacionC } from 'modules/rutinas/component';

moment.locale('es');

const selector = formValueSelector(FORM_VIAJE);

const fechaHoy = new Date();

// Componente de Datos
const DatosTab = ({ desabilitarFechas, trayectos, vehiculos, choferes, params }) => {
  trayectos =
    trayectos.toJS &&
    trayectos.map((trayecto) => ({ nombre: trayecto.get('subnombre') ? trayecto.get('nombre') + ' - ' + trayecto.get('subnombre') : trayecto.get('nombre'), id: trayecto.get('id') })).toJS();

  vehiculos =
    vehiculos &&
    vehiculos
      .map((vehiculo) => {
        let nombre = vehiculo.get('nombre');
        if (vehiculo.get('patente')) nombre += ' - ' + vehiculo.get('patente');
        return { id: vehiculo.get('id'), nombre: nombre };
      })
      .toJS();

  if (vehiculos && vehiculos.length) vehiculos.push({ id: false, nombre: 'Ninguno' });

  choferes =
    choferes &&
    choferes
      .map((chofer) => {
        let nombre = chofer.get('nombre');
        if (chofer.get('apellido')) nombre += ' - ' + chofer.get('apellido');
        if (chofer.get('documento')) nombre += ' - ' + chofer.get('documento');
        return { id: chofer.get('id'), nombre: nombre };
      })
      .toJS();
  if (choferes && choferes.length) choferes.push({ id: false, nombre: 'Ninguno' });
  return (
    <div className="p-lr-10">
      <Row>
        <Col md="12">
          {trayectos && (
            <Field
              name="trayectoId"
              component={AutoCompleteF}
              inputProps={{
                fullWidth: true,
                openOnFocus: true,
                dataSource: trayectos,
                hintText: 'Trayecto',
                floatingLabelText: 'Nombre del trayecto',
                dataSourceConfig: { text: 'nombre', value: 'id' },
                filter: MaterialUI.AutoComplete.caseInsensitiveFilter,
                onClick: (event) => event.target.select(),
              }}
              onBlur={(e) => e.preventDefault()}
              validate={[validations.required, validations.noObject]}
            />
          )}
        </Col>
        <Col md="6">
          <Row>
            <Col md="3">
              <FontAwesome name="calendar" className="fa-2x pt-25" />
            </Col>
            <Col md="9">
              <Field
                name="fecha"
                component={DatePickerF}
                className="fullWidthComponent minHeight55"
                inputProps={{
                  autoOk: true,
                  format: '24hr',
                  fullWidth: true,
                  hintText: 'Fecha de salida',
                  floatingLabelText: 'Fecha salida',
                  shouldDisableDate: desabilitarFechas,
                }}
                format={(value) => (typeof value == 'string' ? null : value)}
                validate={validations.required}
              />
            </Col>
          </Row>
        </Col>
        <Col md="6">
          <Row>
            <Col md="3">
              <FontAwesome name="clock-o" className="fa-2x pt-25" />
            </Col>
            <Col md="9">
              <Field
                name="horario"
                component={TimePickerF}
                className="fullWidthComponent minHeight55"
                inputProps={{
                  autoOk: true,
                  format: '24hr',
                  fullWidth: true,
                  hintText: 'Horario de salida',
                  floatingLabelText: 'Horario salida',
                }}
                format={(value) => (typeof value == 'string' ? null : value)}
                validate={validations.required}
              />
            </Col>
          </Row>
        </Col>
        {choferes && (
          <Col md="12">
            <Field
              name="choferId"
              component={AutoCompleteF}
              inputProps={{
                fullWidth: true,
                openOnFocus: true,
                dataSource: choferes,
                hintText: 'Chofer',
                floatingLabelText: 'Chofer',
                dataSourceConfig: { text: 'nombre', value: 'id' },
                filter: MaterialUI.AutoComplete.caseInsensitiveFilter,
                onClick: (event) => event.target.select(),
              }}
              onBlur={(e) => e.preventDefault()}
              validate={[validations.noObject]}
            />
          </Col>
        )}
        {vehiculos && (
          <Col md="6">
            <Field
              name="vehiculoId"
              component={AutoCompleteF}
              inputProps={{
                fullWidth: true,
                openOnFocus: true,
                dataSource: vehiculos,
                hintText: 'Vehiculo',
                floatingLabelText: 'Vehiculo',
                dataSourceConfig: { text: 'nombre', value: 'id' },
                filter: MaterialUI.AutoComplete.caseInsensitiveFilter,
                onClick: (event) => event.target.select(),
              }}
              onBlur={(e) => e.preventDefault()}
              validate={[validations.noObject]}
            />
          </Col>
        )}

        <Col md="6">
          <Field
            name="precioBoleto"
            component={TextFieldF}
            inputProps={{
              fullWidth: true,
              floatingLabelText: 'Precio boleto',
              hintText: 'Precio boleto',
            }}
            validate={validations.number}
          />
        </Col>
        <Col md="6">
          <Field
            name="cantAsientos"
            component={TextFieldF}
            inputProps={{
              fullWidth: true,
              floatingLabelText: 'Cantidad asientos',
              hintText: 'Cantidad  Asientos',
            }}
            validate={validations.number}
          />
        </Col>
        <Col md="6">
          <Field
            name="admitirAcompanantes"
            component={TextFieldF}
            inputProps={{
              fullWidth: true,
              floatingLabelText: 'Admitir acompañantes',
              hintText: 'Número de acompañantes',
            }}
            validate={validations.number}
          />
        </Col>
        <Col md="6">
          <Field
            name="admitirCambioParadasHastaMinutosPrevios"
            component={TextFieldF}
            inputProps={{
              fullWidth: true,
              floatingLabelText: 'Minutos previos permitir cambio de paradas',
              hintText: 'Minutos previos',
              floatingLabelStyle: { fontSize: '0.8rem' },
            }}
            validate={validations.number}
          />
        </Col>
        <Col md="6">
          <Field
            name="admitirReservasHastaMinutosPrevios"
            component={TextFieldF}
            inputProps={{
              fullWidth: true,
              floatingLabelText: 'Minutos previos para admitir reservas',
              hintText: 'Minutos previos',
              floatingLabelStyle: { fontSize: '0.8rem' },
            }}
            validate={validations.number}
          />
        </Col>

        <Col md="12" style={{ paddingTop: 20 }}>
          {params.viajeId !== 'new' && (
            <div>
              <Field
                name="creadoPorRutina"
                component={ToggleFieldF}
                inputProps={{
                  label: 'Creado por rutina',
                  className: 'fullWidthComponent p10',
                  disabled: true,
                }}
              />
              <MaterialUI.Divider />
            </div>
          )}
          <Field
            name="publico"
            component={ToggleFieldF}
            inputProps={{
              label: 'Publico',
              className: 'fullWidthComponent p10',
            }}
          />
          <MaterialUI.Divider />
          <Field
            name="finalizado"
            component={ToggleFieldF}
            inputProps={{
              label: 'Finalizado',
              className: 'fullWidthComponent p10',
            }}
          />
          <MaterialUI.Divider />
          <Field
            name="reservable"
            component={ToggleFieldF}
            inputProps={{
              label: 'Admite reservas',
              className: 'fullWidthComponent p10',
            }}
          />
          <MaterialUI.Divider />
          <Field
            name="permiteCambioParadas"
            component={ToggleFieldF}
            inputProps={{
              label: 'Permitir cambio paradas',
              className: 'fullWidthComponent p10',
            }}
          />
          <MaterialUI.Divider />
          <Field
            name="forzarReporte"
            component={ToggleFieldF}
            inputProps={{
              label: 'Reporte chofer obligatorio',
              className: 'fullWidthComponent p10',
            }}
          />
          <MaterialUI.Divider />
          <Field
            name="fueraDeServicio"
            component={ToggleFieldF}
            inputProps={{
              label: 'Fuera de servicio',
              className: 'fullWidthComponent p10',
            }}
          />
          <MaterialUI.Divider />
        </Col>
      </Row>
    </div>
  );
};

const GruposTab = ({ gruposList, gruposViaje, seleccionGrupo }) => {
  return !gruposList || gruposList.size == 0 ? (
    <div className="p-lr-10">No hay grupos</div>
  ) : (
    <div>
      {gruposList.map((grupo) => (
        <div className="p-lr-10" key={grupo.get('id')}>
          <MaterialUI.Divider className="mb-10" />
          <MaterialUI.Toggle toggled={gruposViaje && gruposViaje.findIndex((i) => i === grupo.get('id')) !== -1} onToggle={(e, a) => seleccionGrupo(grupo.get('id'), a)} label={grupo.get('nombre')} />
        </div>
      ))}
    </div>
  );
};

class Add extends React.Component {
  componentDidMount() {
    this.props.dispatch(trayectosActions.get());
    this.props.dispatch(vehiculosActions.seleccionarChofer());
    this.props.dispatch(gruposActions.get());
    this.props.dispatch(vehiculosActions.get());
    if (this.props.params.viajeId === 'new') this.props.dispatch(generalActions.dashboard_changeTitle('AGREGAR VIAJE'));
    else {
      this.props.dispatch(generalActions.dashboard_changeTitle('MODIFICAR VIAJE'));
      this.props.dispatch(viajesActions.getById(this.props.params.viajeId, true));
    }
  }
  componentWillUnmount = () => this.props.dispatch(viajesActions.clear('viaje'));
  seleccionGrupo = (grupo, agregar) => this.props.dispatch(viajesActions.setGrupo(grupo, agregar));
  desabilitarFechas = (date) => moment(date).startOf('day').toDate() < moment().startOf('day').toDate().getTime();
  submitForm = (data) => {
    const { gruposViaje } = this.props;
    let dataSend = Object.assign({}, data.toJS()),
      hour = moment(dataSend.horario).hour(),
      minutes = moment(dataSend.horario).minutes();

    dataSend.horario = moment(dataSend.fecha).hour(hour).minutes(minutes).toDate();
    dataSend.cantAsientos = Number(dataSend.cantAsientos);
    if (dataSend.precioBoleto) dataSend.precioBoleto = Number(dataSend.precioBoleto);

    if (dataSend.penalizacionCancelacionCosto) dataSend.penalizacionCancelacionCosto = Number(dataSend.penalizacionCancelacionCosto);
    delete dataSend.creadoPorRutina;
    delete dataSend.fecha;
    dataSend.grupos = gruposViaje;
    if (!dataSend.vehiculoId) dataSend.vehiculoId = '';
    if (!dataSend.choferId) dataSend.choferId = '';

    if (dataSend.penalizacionCancelacionMinutosPrevios) dataSend.penalizacionCancelacionMinutosPrevios = Number(dataSend.penalizacionCancelacionMinutosPrevios);

    if (dataSend.admitirCambioParadasHastaMinutosPrevios) dataSend.admitirCambioParadasHastaMinutosPrevios = Number(dataSend.admitirCambioParadasHastaMinutosPrevios);
    if (dataSend.admitirReservasHastaMinutosPrevios) dataSend.admitirReservasHastaMinutosPrevios = Number(dataSend.admitirReservasHastaMinutosPrevios);
    if (dataSend.admitirAcompanantes) dataSend.admitirAcompanantes = Number(dataSend.admitirAcompanantes);
    console.log('dataSend', dataSend);
    this.props.dispatch(viajesActions.set(dataSend, this.props.params.viajeId));
  };
  setMapRef = (map) => (this.mapRef = map);
  fitCoor = (salida, destino) => {
    if (this.mapRef && salida && destino) {
      let bounds = new window.google.maps.LatLngBounds();
      bounds.extend(new window.google.maps.LatLng(salida.lat, salida.lng));
      bounds.extend(new window.google.maps.LatLng(destino.lat, destino.lng));
      this.mapRef.fitBounds(bounds);
    }
  };
  verTrayecto = () => this.props.dispatch(push('/dashboard/viajes/trayecto/' + this.props.params.viajeId));
  render() {
    let { trayecto, params, localizacion, pristine, cantReservas, publico, reservable, precioBoleto, penalizacionCancelacionCosto } = this.props;

    const invalid = this.props.invalid;
    trayecto = trayecto ? Polyline.decode(trayecto).map((point) => ({ lat: point[0], lng: point[1] })) : null;
    if (trayecto && trayecto[0] && trayecto[trayecto.length - 1]) this.fitCoor(trayecto[0], trayecto[trayecto.length - 1]);

    return (
      <Container fluid={true}>
        <form onSubmit={this.props.handleSubmit(this.submitForm)}>
          <Row>
            <Col md="6">
              <MaterialUI.Paper zDepth={2} className="padding">
                <MaterialUI.Tabs>
                  <MaterialUI.Tab label="Datos">
                    <DatosTab {...this.props} />
                  </MaterialUI.Tab>
                  {!publico && (
                    <MaterialUI.Tab label="Grupos">
                      <GruposTab {...this.props} />
                    </MaterialUI.Tab>
                  )}
                  <MaterialUI.Tab label="Penalizaciones">
                    <PenalizacionCancelacionC
                      hasReservas={cantReservas > 0}
                      reservable={reservable}
                      precioBoleto={precioBoleto}
                      penalizacionCancelacionCosto={penalizacionCancelacionCosto}
                      penalizacionCancelacionPorcentaje={false}
                    />
                  </MaterialUI.Tab>
                </MaterialUI.Tabs>
              </MaterialUI.Paper>
            </Col>
            <Col md="6">
              <MaterialUI.Paper zDepth={2} className="padding">
                <MaterialUI.Tabs>
                  <MaterialUI.Tab label="Trayecto">
                    <div style={{ height: 800 }}>
                      <GMapsC
                        mapRef={(map) => this.setMapRef(map)}
                        trayecto={trayecto}
                        multipleMarkers={trayecto ? [trayecto[0], trayecto[trayecto.length - 1]] : []}
                        mapElement={<div style={{ height: '100%' }} />}
                        containerElement={<div style={{ height: '100%' }} />}
                      />
                    </div>
                    {params.viajeId && localizacion && localizacion.size > 0 && (
                      <MaterialUI.RaisedButton primary={true} label="VER RECORRIDO REALIZADO" onClick={this.verTrayecto} className="fullWidthComponent noPadding" />
                    )}
                  </MaterialUI.Tab>
                </MaterialUI.Tabs>
              </MaterialUI.Paper>
            </Col>
          </Row>
          <Row>
            <Col md="12">
              <MaterialUI.RaisedButton type="submit" primary={true} label="GUARDAR" disabled={invalid || pristine} className="fullWidthComponent noPadding m-tb-20" />
            </Col>
          </Row>
          <CancelarButtonC className="m-tb-20" dispatch={this.props.dispatch} />
        </form>
      </Container>
    );
  }
}

Add = reduxForm({
  form: FORM_VIAJE,
  enableReinitialize: true,
})(Add);

Add = connect((store) => {
  const horario = store.getIn(['viajes', 'viaje', 'horario']),
    reservable = store.getIn(['viajes', 'viaje', 'reservable']),
    permiteCambioParadas = store.getIn(['viajes', 'viaje', 'permiteCambioParadas']),
    publico = store.getIn(['viajes', 'viaje', 'publico']);
  return {
    trayectos: store.getIn(['trayectos', 'lista']),
    trayecto: (store.getIn(['trayectos', 'lista']).find((t) => t.get('id') == selector(store, 'trayectoId')) || Map()).get('polyline'),
    localizacion: store.getIn(['viajes', 'viaje', '_localizacion']),
    vehiculos: store.getIn(['vehiculos', 'lista']),
    choferes: store.getIn(['general', 'seleccionador', 'listas', '_chofer']),
    gruposList: store.getIn(['grupos', 'lista']),
    gruposViaje: store.getIn(['viajes', 'viaje', 'grupos']),
    publico: selector(store, 'publico'),
    penalizacionCancelacionCosto: selector(store, 'penalizacionCancelacionCosto'),
    precioBoleto: selector(store, 'precioBoleto'),
    reservable: selector(store, 'reservable'),
    cantReservas: store.getIn(['viajes', 'viaje', 'cantReservas']) || 0,
    initialValues: {
      fecha: horario ? new Date(horario) : fechaHoy,
      horario: horario ? new Date(horario) : fechaHoy,
      trayectoId: store.getIn(['viajes', 'viaje', 'trayectoId']),
      cantAsientos: store.getIn(['viajes', 'viaje', 'cantAsientos']) || 19,
      choferId: store.getIn(['viajes', 'viaje', 'choferId']),
      vehiculoId: store.getIn(['viajes', 'viaje', 'vehiculoId']),
      fueraDeServicio: store.getIn(['viajes', 'viaje', 'fueraDeServicio']) || false,
      finalizado: store.getIn(['viajes', 'viaje', 'finalizado']) || false,
      reservable: typeof reservable == 'undefined' ? true : reservable,
      permiteCambioParadas: typeof permiteCambioParadas == 'undefined' ? true : permiteCambioParadas,
      publico: Boolean(publico),
      precioBoleto: store.getIn(['viajes', 'viaje', 'precioBoleto']),
      penalizacionCancelacionCosto: store.getIn(['viajes', 'viaje', 'penalizacionCancelacionCosto']),
      penalizacionCancelacionMinutosPrevios: store.getIn(['viajes', 'viaje', 'penalizacionCancelacionMinutosPrevios']),
      admitirCambioParadasHastaMinutosPrevios: store.getIn(['viajes', 'viaje', 'admitirCambioParadasHastaMinutosPrevios']),
      admitirReservasHastaMinutosPrevios: store.getIn(['viajes', 'viaje', 'admitirReservasHastaMinutosPrevios']),
      admitirAcompanantes: store.getIn(['viajes', 'viaje', 'admitirAcompanantes']),
      forzarReporte: Boolean(store.getIn(['viajes', 'viaje', 'forzarReporte'])),
      creadoPorRutina: Boolean(store.getIn(['viajes', 'viaje', 'rutinaId'])),
    },
  };
})(Add);

export default Add;



// WEBPACK FOOTER //
// src/modules/viajes/components/add.js